import mitt from 'mitt';

// Global event bus
const emitter = mitt()
export default emitter;